import $ from 'jquery';
import 'magnific-popup';

let compil = {
    init() {
        checkContracts();

        $(document).on('click', '.form-compil .button.reset', function () {
            $('.form-compil').get(0).reset();
        });

        $(document).on('submit', '.form-compil', function (event) {
            event.preventDefault();
            if (!$('#startDate').val() && !$('#endDate').val()) {
                $('.form-compil .button.reset').addClass('visually-hidden');
            }
            let url = $(this).attr('data-url');
            $.ajax({
                method: "POST",
                url: url,
                data: {
                    'start_date': $('#startDate').val(),
                    'end_date': $('#endDate').val(),
                },
                beforeSend: function () {
                    //Afficher le loader
                    $('body').after(Drupal.theme.ajaxProgressIndicatorFullscreen());
                },
                success: function (data, status) {
                    if ($('#startDate').val() || $('#endDate').val()) {
                        $('.form-compil .button.reset').removeClass('visually-hidden');
                    }
                    $('.b-listing').empty();
                    $('.b-listing').html(data);
                },
                complete: function () {
                    //Cacher le loader
                    $(".ajax-progress-fullscreen").remove();
                },
                error: function (data, status) {
                    console.log(data, status);
                }
            });

        });

        function checkContracts() {
            $.ajax({
                method: "POST",
                url: '/ekko_compil/compil/check_contracts',
                success: function (data, status) {
                    if (data == 1) {
                        $('.main-menu nav a.alert-contract').addClass('actif');
                        $('.main-menu nav a.ext-compil').addClass('actif');
                        if ($('.header-page .ssnav').length) {
                            $('.header-page .ssnav li a.alert-contract').addClass('actif');
                            $('.header-page .ssnav li a.ext-compil').addClass('actif');
                        }
                    }
                },
                error: function (data, status) {
                    console.log('error');
                    console.log(data, status);
                }
            });
        }

        $(document).on('click', '.ajax-popup', function (event) {
            event.preventDefault();
            $(this).magnificPopup({
                type: 'ajax',
                overflowY: 'auto',
                mainClass: 'mfp-fade',
                midClick: true,
                closeOnBgClick: false
                //modal: true,
            }).magnificPopup('open')
        });


    }
}

export default compil;
